import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import React, {useEffect, useState} from "react";
import axios from "axios";
import {useParams} from "react-router-dom";
import {Card} from "react-bootstrap";
import {FaFacebook, FaLinkedin, FaMailBulk} from "react-icons/fa";
import CarouselBooks from "../carouselBooks/CarouselBooks";
import TextLoader from "../../../components/TextLoader/TextLoader";
import { format } from 'date-fns'

import Dialog from "../create/dialog";
import ProtectedAccess  from '../../../components/ProtectedAccess'

import '../style.css'

function AuthorDetails(props) {

    const { lang = {}, id } = props;

    const params = useParams()
    const authorId = params.id || id
    const [author, setAuthor] = useState(null);
    const [authorBooks, setAuthorBooks] = useState(null);
    const [loading, setLoading] = useState(true);

    const [show, setShow] = useState(false);
    const [current, setCurrent] = useState(null);


    async function getData() {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/authors/${authorId}`)
        const { data } = response;
        setAuthor(data)
        setCurrent(data)
        setAuthorBooks(data.books)
        setLoading(false);
    }

    const handleClose = async () => {
        setCurrent(null);
        setShow(false);
      };
    
      const handleShow = (user) =>{
        setCurrent(user)
        setShow(true)
      };

    useEffect(() => {
        getData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (loading) {
        return (<TextLoader
            upperMessage={'Cargando'} //lang.author.loading.books_upper}
            lowerMessage={'Se esta obteniendo los datos del author'} //lang.author.loading.books_lower}
            />
        )
    };

    return (
        <div style={{
            display:'flex',
            flexDirection:'column'
        }}> 
            <Card className='header-author mt-2'>
                <Dialog
                    show={show} 
                    handleClose={handleClose}
                    lang={lang}
                    current={current}
                    onFinish={getData}
                />
                <Row>
                    <Col 
                        xs={{span: 12, order:1}} sm={{span: 12, order:1}} md={{span: 4, order:0}} xl={{span: 4, order:0}}
                        style={{
                            display:'flex',
                            alignItems:'center',
                            justifyContent:'center',
                            padding:'2px'
                        }}> 
                        <Card.Img src={author.photo || '/assets/app/author.png'} alt={author.id} className="image-rounded mx-auto d-block" style={{maxWidth:'250px',margin:'1.5rem'}} />
                    </Col>
                    <Col xs={{span: 12, order:1}} sm={{span: 12, order:1}} md={{span: 8, order:1}} xl={{span: 8, order:1}}>
                        <Card.Body>
                            <h3>{author.firstName} {author.lastName} </h3>
                            {/* {author.birthDate && <span><b>Fecha de nacimiento:</b> {format(new Date(author.birthDate), 'yyyy-MM-dd')}<br/></span>}
                            {author.deathDate && <span><b>Fecha de defunción:</b> {format(new Date(author.deathDate), 'yyyy-MM-dd')}<br/></span>} */}
                            
                            
                            {/*author.gender == "unselected" ? <span><b>Sexo:</b> No definido<br/></span>: null}
                            {author.gender == "male" ? <span><b>Sexo:</b> Masculino<br/></span>: null}
                            {author.gender == "female" ? <span><b>Sexo:</b> Femenino<br/></span>: null}
                            {author.gender == "nobinary" ? <span><b>Sexo:</b> No binario<br/></span>: null*/}
                            

                            <div className="py-3">
                                <div dangerouslySetInnerHTML={{__html: author.description}} />
                            </div>
                            {/* <div className="">
                                { (author.email || author.facebook || author.linkedin || author.cvlac)
                                    &&
                                    <span><strong>Algunos datos de contacto</strong><br/></span>
                                }
                                {author.email && <span><FaMailBulk /> <a href={`mailto:${author.email}`}> {author.email}</a> <br/></span>}
                                {author.facebook && <span><FaFacebook /> <a href={author.facebook}> {author.facebook}</a> <br/></span>}
                                {author.linkedin && <span><FaLinkedin /> <a href={author.linkedin}> {author.linkedin}</a> <br/></span>}
                                {author.cvlac && <span>CvLAC <a href={author.cvlac}> {author.cvlac}</a><br/><br/></span>}

                                {/* {author.gender=='male'?'Reconocido autor ':'Reconocida autora '}
                                {author?.country? `de nacionalidad ${author?.country}`:""}
                                que aparece en nuestro catálogo desde el {format(new Date(author.createdAt), 'yyyy-MM-dd')} {' '}
                                y actualmente tenemos {author?.books?.length} de sus obras en el catálogo. */}

                            {/* </div> */}
                            <ProtectedAccess 
                                element={
                                    <button className="btn btn-sm btn-primary btn-block badge" type="button" onClick={()=>handleShow(author)} > Modificar</button>
                                }
                                role={['admin', 'editor']}
                            />
                        </Card.Body>
                    </Col>
                </Row>
            </Card>
            {authorBooks.length > 0 && <Row className='mt-2'>
                <div>
                    <p>
                        <strong>Obras de {author.firstName} {author.lastName}</strong>
                    </p>
                </div>
                <CarouselBooks books={authorBooks}/>
            </Row>}
            <Row className='mt-2'>
                <div>
                    {(author.academictitle || author.research || author.papers) && <p>
                        <strong>Otros datos de {author.firstName} {author.lastName}</strong><br/>
                    </p>}
                    
                    {author.academictitle && <div>
                        <span className='titulo-texto'>Formación Académica</span><br/>
                        <p dangerouslySetInnerHTML={{__html: author.academictitle}} /><p>
                            <span className='titulo-texto'>Facultad / Escuela / Departamento</span><br/>
                            {author.university || 'No establecido'}
                        </p>
                    </div>}
                    
                    {author.research && <div>
                        <span className='titulo-texto'>Líneas de investigación</span><br/>
                        <p dangerouslySetInnerHTML={{__html: author.research}} />
                    </div>}

                    {author.papers && <div>
                        <span className='titulo-texto'>Artículos</span><br/>
                        <p dangerouslySetInnerHTML={{__html: author.papers}} className="author-div-papers"/>
                    </div>}
                </div>
            </Row>
        </div>
    );
}
AuthorDetails.propTypes = {

};
export default AuthorDetails;
